import { render } from "./ViewClient.vue?vue&type=template&id=ec6c47ce"
import script from "./ViewClient.vue?vue&type=script&lang=js"
export * from "./ViewClient.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__